<template>
  <div class="building-container" :class="{
    isMobile: isMobile()
  }">
    <div class="block-title">党建学习</div>

    <div class="item-block">
      <newsBlock :dataInfo="item" :key="index" v-for="(item, index) in contentList" />
    </div>

    <div class="text-center">
      <el-pagination
        background
        @current-change="currentPageChange"
        :current-page.sync="page"
        :page-size="pageSize"
        layout="prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import newsBlock from '@/components/newsBlock'
import { MODULE_CONFIG } from '@/config/index'
import { fetchContentList } from '@/api/content'
import pageMixins from '@/mixins/page'
import { isMobile } from '@/utils/index'

export default {
  mixins: [pageMixins],
  components: {
    newsBlock
  },

  data() {
    return {
      contentList: []
    }
  },
  methods: {
    isMobile,
    async getContentList() {
      try {
        const { data, total } = await fetchContentList({
          page: this.page,
          pageSize: this.pageSize,
          pid: MODULE_CONFIG.US,
          cate_id: MODULE_CONFIG.BUILDING
        })

        this.contentList = data
        this.total = total
      } catch (error) {
        
      }
    }
  },
  created() {
    this.getContentList()
  }
}
</script>

<style lang="scss">
.building-container {

  &.isMobile {
    .item-block {
      margin-bottom: 79px;

      .newBlock.item {
        .right-content {
          .left-img {
            width: 100%;
            height: inherit;
            
          }
        }
      }
    }
  }

  .item-block {
    margin-bottom: 79px;

    .newBlock.item {
      .right-content {
        .left-img {
          width: 258px;
          height: 145px;
        }
      }
    }
  }
  
}
</style>
